<template>
  <div>
    <header>
      <div class="background-video-overlay"></div>
      <!-- <div class="containersss h-100">
        <div class="d-flex h-100 text-center align-items-center">
          <div class="w-100 text-white">
            <h1 >DAL 1979</h1>
            <p>al vostro servizio</p>
          </div>
        </div>
      </div> -->
      <video id="background-video" autoplay muted loop>
        <source
          src="@/assets/videos/artfiber.mp4"
          type="video/mp4"
        >
          Your browser does not support HTML5 video.
      </video>
      <img
        id="header-image"
        src="@/assets/images/header/contacts.jpg"
      />
    </header>
    <!-- Holidays Section -->
    <!-- <section class="home_section home_section_bg_colored">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="ferie">
              <img
                src="@/assets/images/common/reindeer.png"
              />
              <br/><br/>
              <span style="white-space: pre-line;">{{ $t("home_section_ferie_natalizie.body") }}</span>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- Artigianale Section -->
    <section class="home_section">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>{{ $t("home_section_lavorazione_artigianale.title") }}</h2>
            <hr/>
            <div class="clear_big"/>
            <div class="clear_big"/>
            <p>
              <span style="white-space: pre-line;">{{ $t("home_section_lavorazione_artigianale.body") }}</span>
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Materie Section -->
    <section class="home_section home_section_bg_colored">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>{{ $t("home_section_materie_prime_qualita.title") }}</h2>
            <hr/>
            <div class="clear_big"/>
            <div class="clear_big"/>
            <p>
              <span style="white-space: pre-line;">{{ $t("home_section_materie_prime_qualita.body") }}</span>
              <div class="clear_big"/>
              <div class="clear_big"/>
              <img
                src="@/assets/images/home/materials.png"
                class="home_section_full_width_img"
              />
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Scopri Section -->
    <section class="home_section">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>{{ $t("home_section_kayak_adatto_a_te.title") }}</h2>
            <hr/>
            <div class="clear_big"/>
            <div class="clear_big"/>
            <p>
              <span style="white-space: pre-line;">{{ $t("home_section_kayak_adatto_a_te.body") }}</span>
              <div class="clear_big"/>
              <div class="clear_big"/>
              <img
                src="@/assets/images/home/indoor.png"
                class="home_section_full_width_img"
              />
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Partners Section -->
    <section class="home_section">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>{{ $t("home_section_i_nostri_partners.title") }}</h2>
            <hr/>
            <div class="clear_big"/>
            <div class="clear_big"/>
            <span>
              <a
                href="https://www.prijon.com"
                target="_blank"
              >
                <img
                  src="@/assets/images/partners/logo_prijon.png"
                  class="partner_image"
                />
              </a>
            </span>
            <div class="clear_big"/>
            <div class="clear_big"/>
            <span>
              <a
                href="https://loscalo.it"
                target="_blank"
              >
                <img
                  src="@/assets/images/partners/logo_lo_scalo.png"
                  class="partner_image"
                />
              </a>
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>
